// Razorpay Merchant Policy URLs
// These are the legally required policy pages registered with Razorpay for live payments.
export const RAZORPAY_POLICIES = {
  terms:    "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/terms",
  contact:  "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/contact_us",
  refund:   "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/refund",
  privacy:  "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/privacy",
  shipping: "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/shipping",
};

// Common Razorpay checkout configuration applied to all payment flows.
// send_sms_hash  → allows Android to auto-read OTPs for a smoother UX.
// allow_rotation → allows landscape on mobile devices.
// retry          → automatically retries failed payments up to 3 times.
// timeout        → closes the checkout if the user is idle for 5 minutes.
// config.display → shows all payment method blocks by default; keeps the topbar visible.
export const RAZORPAY_CHECKOUT_CONFIG = {
  send_sms_hash: true,
  allow_rotation: false,
  retry: { enabled: true, max_count: 3 },
  timeout: 300,
  config: {
    display: {
      hide_topbar: false,
      preferences: {
        show_default_blocks: true,
      },
    },
  },
};
